/**
 * AssetLoadingError
 */ export class AssetLoadingError extends Error {
    constructor(name, message){
        super();
        this.name = "AssetLoadingError";
        this.message = `${name}${message ? ". " + message : ""}`;
    }
}
